import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";


export default {
    namespaced: true,
    state: {
        inventory: [],
        inventoryDetails: {
            id: null,
            medicineName: null,
            medicineType: null,
            dosage: null,
            departmentName: null,
            description: null,
            createdBy: null,
            createdOn: null,
            status: null,
        },
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.inventory.findIndex(i => i.id === id)
    },
    mutations: {
        SetItems: (state, data) => state.inventory = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SetItem: (state, viewData) => state.inventoryDetails = viewData,
        ADD: (state, addedData) => state.inventory.unshift(addedData),
        UPDATE: (state, { index, updateData }) => state.inventory.splice(index, 1, updateData),
        DELETE: (state, index) => state.inventory.splice(index, 1),
    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");

                const response = await dataService.inventory.getAll(paramsString);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SetItems', response.data.inventory);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getDetails({ commit }, id) {
            startLoading()
            try {
                commit('SetItem', {});
                const response = await dataService.inventory.getDetails(id);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SetItem', response.data.inventory);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        }, 
         async getForEdit(_, id) {
            startLoading()
            try {
                const response = await dataService.inventory.getForEdit(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data.inventory);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
       

        async add({ commit }, payload) {
            startLoading()
            try {
                const response = await dataService.inventory.add(payload);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);
                commit('ADD', response.data.inventory);
            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);

            }
        },
        async edit({ commit, getters }, { id, payload }) {
            startLoading()
            try {
                const response = await dataService.inventory.edit(id,payload);

                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('UPDATE', { index: index, updateData: response.data.inventory });

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);

            }
        },
        async delete({ commit, getters }, id) {
            startLoading()
            try {
                const response = await dataService.inventory.delete(id);

                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('DELETE', index);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
    },
};
